import { Box } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import SelectField from 'modules/core/components/SelectField'
import i18n from 'modules/core/lib/i18n'

import RangeDatePicker from 'modules/shift_management/components/ShiftManagement/RangeDatePicker'
import SingleDatePicker from 'modules/shift_management/components/ShiftManagement/SingleDatePicker'
import TooltipIcon from 'modules/shift_management/components/ShiftManagement/TooltipIcon'
import type CommonSelectorsForm from 'modules/shift_management/lib/forms/CommonSelectorsForm'
import { TIME_PERIODS } from 'modules/shift_management/lib/forms/CommonSelectorsForm'
import type { Leave } from 'modules/shift_management/lib/types'

import CustomDaysSelector from './CustomDaysSelector'

export interface Props {
  form: CommonSelectorsForm
  leave?: Leave
}

const TimePeriodSelector = ({ form, leave }: Props) => {
  const timePeriodOptions = [
    {
      label: i18n.t('shift_management.actions_sidepanel.time_period.does_not_repeat'),
      value: TIME_PERIODS.DOES_NOT_REPEAT,
    },
    {
      label: i18n.t('shift_management.actions_sidepanel.time_period.daily'),
      value: TIME_PERIODS.DAILY,
    },
    {
      label: i18n.t('shift_management.actions_sidepanel.time_period.custom_period'),
      value: TIME_PERIODS.CUSTOM_PERIOD,
    },
  ]

  const minDateFromLeave = leave?._startOn
  const maxDateFromLeave = leave?._finishOn

  return (
    <Box gap="s16" flexDirection="row">
      <TooltipIcon.Medium
        icon="calendar"
        label={i18n.t('shift_management.actions_sidepanel.tooltip.date_period')}
        color="grey700"
      />

      <Box gap="s8" width="full">
        <SelectField
          onChange={(time_period) => form.setValues({ time_period: time_period })}
          value={form.get('time_period').value}
          options={timePeriodOptions}
        />

        {form.doesNotRepeat ? (
          <SingleDatePicker
            date={form.get('start_date')}
            hideLabel
            minDateFromLeave={minDateFromLeave}
            maxDateFromLeave={maxDateFromLeave}
          />
        ) : (
          <>
            <RangeDatePicker
              startDate={form.get('start_date')}
              endDate={form.get('end_date')}
              hideLabel
              minDateFromLeave={minDateFromLeave}
              maxDateFromLeave={maxDateFromLeave}
            />
            {form.isCustomPeriod && <CustomDaysSelector field={form.get('apply_on_days')} />}
          </>
        )}
      </Box>
    </Box>
  )
}

export default observer(TimePeriodSelector)
